import { waitForTransition } from '@/roadmaps/helpers/roadmaps.helper';
import { ref, unref } from 'vue';
import { useVocItemsStore } from '@/stores/voc-items.store';

let blades = {};
const currentOpenBlade = ref(null);

export function useBlades () {
    const registerBlades = (bladesToRegister) => {
        blades = bladesToRegister;
    };

    const closeAllBlades = () => {
        currentOpenBlade.value = null;

        return waitForTransition();
    };

    const isBladeOpen = (key) => {
        return !!unref(currentOpenBlade) && unref(currentOpenBlade).key === key;
    };

    const openBlade = async (bladeKey, bladeProps) => {
        if (!blades[bladeKey]) return;

        const isADifferentBladeOpen = !!unref(currentOpenBlade) && !isBladeOpen(bladeKey);
        if (isADifferentBladeOpen) {
            await closeAllBlades();
        }

        const isIdeaBladeOpen = !!useVocItemsStore().bladeActiveItem;
        if (isIdeaBladeOpen) {
            useVocItemsStore().closeBlade();
            await waitForTransition();
        }

        currentOpenBlade.value = {
            ...blades[bladeKey],
            props: bladeProps,
        };
    };

    return {
        currentOpenBlade,
        registerBlades,
        openBlade,
        closeAllBlades,
        isBladeOpen,
    };
}
